exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-0cda2835]{margin:20px}.icongengduo1[data-v-0cda2835]{color:#909399}.img[data-v-0cda2835]{width:22px;height:22px;border-radius:50%;margin-right:6px;vertical-align:middle}\n", ""]);

// exports
